<template>
  <div v-if="show" class="center" :style="`height:${bodyHeight - 80}px`">
    <div class="container mt-4">
      <div class="google-map" id="map1"></div>
      <div class="btns" :style="`width:${bodyWidth - 260 * 1 - 35}px`">
        <div class="cancel" @click="handCancel">Cancel</div>
        <div class="zdy-input">
          <div class="input">
            <input
              style="text-align: center;"
              type="number"
              v-model="radus"
              @input="handInput"
            />
          </div>
          <div class="danwei">m</div>
        </div>
        <div class="confirm" @click="handConfirm">OK</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMapKeys } from "@/api/user.js";
export default {
  data() {
    return {
      timer: null,
      radus: 2000,
      selectInfo: {},
      markers: [],
      infowindows: [],
      bodyWidth: document.body.clientWidth || window.innerWidth,
      bodyHeight: document.body.clientHeight || window.innerHeight,
      map: null,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      show: false,
    };
  },
  methods: {
    handInput(e) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      console.log(e);
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        this.handBlur(e);
      }, 500);
    },
    handBlur(e) {
      if (!e.target._value) {
        return;
      }
      if (Number(e.target._value) <= 0) {
        return;
      }
      this.radus = Number(e.target._value);
      if (this.selectInfo && this.selectInfo.lat) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
        this.initCircular(this.selectInfo);
        this.setMarker(this.selectInfo.lat, this.selectInfo.lng, 0);
      }
    },
    handCancel() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
      this.infowindows.forEach((el) => {
        el.infowindow.close();
      });
      this.show = false;
    },
    handConfirm() {
      if (!this.selectInfo && !this.selectInfo.lat) {
        return;
      }
      const params = {
        ...this.selectInfo,
        radus: this.radus,
      };
      this.$emit("change", params);
      this.handCancel();
    },
    showEdit(row) {
      this.show = true;
      if (row && row.radus) {
        this.radus = row.radus;
      } else {
        this.radus = 2000;
      }
      this.$nextTick(() => {
        this.initMap(row);
      });
    },
    async initMap(row) {
      const ddd = await getMapKeys();
      // eslint-disable-next-line no-undef
      const map = new google.maps.Map(document.getElementById("map1"), {
        center: {
          lat: this.lat,
          lng: this.lng,
        },
        zoom: 15,
        maxZoom: 20,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        disableDefaultUI: false,
        zoomControl: false,
        scaleControl: false,
        // eslint-disable-next-line no-dupe-keys
        mapTypeControl: false,
        // eslint-disable-next-line no-dupe-keys
        streetViewControl: false,
      });
      map.addListener("click", (mapsMouseEvent) => {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
        this.selectInfo = {
          lat: mapsMouseEvent.latLng.lat(),
          lng: mapsMouseEvent.latLng.lng(),
        };
        this.initCircular(this.selectInfo);
        this.setMarker(
          mapsMouseEvent.latLng.lat(),
          mapsMouseEvent.latLng.lng(),
          0
        );
      });
      this.map = map;
      if (row && row.latitude) {
        this.selectInfo = {
          ...row,
          lat: Number(row.latitude),
          lng: Number(row.longitude),
        };
        this.initCircular(this.selectInfo);
        this.setMarker(this.selectInfo.lat, this.selectInfo.lng, row.radus);
      }
    },
    initCircular(worldCoordinate) {
      const citymap = {
        chicago: {
          center: {
            lat: worldCoordinate.lat,
            lng: worldCoordinate.lng,
          },
          population: this.radus / 100,
        },
      };
      for (const city in citymap) {
        // eslint-disable-next-line no-undef
        const cityCircle = new google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: this.map,
          center: citymap[city].center,
          radius: Math.sqrt(citymap[city].population) * 100,
        });
        console.log(cityCircle);
        this.markers.push(cityCircle);
      }
    },
    setMarker(lat, lng, index) {
      lat = lat || this.lat;
      lng = lng || this.lng;
      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        icon: {
          url: "http://apidemo.spylix.com/img/location.png",
          // eslint-disable-next-line no-undef
          scaledSize: new google.maps.Size(50, 50),
        },
        map: this.map,
      });
      this.markers.push(marker);
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);
      // eslint-disable-next-line no-undef
      var infowindow = new google.maps.InfoWindow({
        content: `<div style="padding: 10px; max-width: 220px">
                        <div style="line-height: 23px;">
                            <span>Latitude</span>
                            <span style="padding-left: 5px">${latLng
                              .lat()
                              .toFixed(7)}</span>
                        </div>
                        <div style="line-height: 23px;">
                            <span>Longitude</span>
                            <span style="padding-left: 5px">${latLng
                              .lng()
                              .toFixed(7)}</span>
                        </div>
                    </div>`,
      });
      this.infowindows.push({
        id: index,
        infowindow: infowindow,
      });
      infowindow.open(this.map, marker);
      // eslint-disable-next-line no-undef
      google.maps.event.addListener(marker, "click", () => {
        this.infowindows.forEach((el) => {
          el.infowindow.close();
        });
        this.$nextTick(() => {
          infowindow.open(this.map, marker);
        });
      });
    },
  },
};
</script>

<style scoped>
.center {
  width: 97%;
  margin: 20px auto;
  position: absolute;
  top: 0;
}
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.google-map {
  /* width: 750rpx; */
  flex: 1;
}

.btns {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 46px;
  position: fixed;
  background-color: #fff;
  bottom: 0;
}
.btns .cancel {
  color: #c8c9cc;
  font-size: 16px;
}
.btns .zdy-input {
  /* width: 130px; */
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0 24px;
}
.danwei {
  margin-left: 20px;
}
.btns .confirm {
  color: #2979ff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/selection.vue